require('./rulesContent/SportsRulesENG.pdf');
require('./rulesContent/SportsRulesFR.pdf');
require('./rulesContent/SportsRulesSPA.pdf');
require('./rulesContent/SportsRulesPT.pdf');

const rules = {
    eng: '/rules/SportsRulesENG.pdf',
    fra: '/rules/SportsRulesFR.pdf',
    spa: '/rules/SportsRulesSPA.pdf',
    por: '/rules/SportsRulesPT.pdf'
};

module.exports = {
    termsAndConditions: [
        {
            'title': {
                'eng': 'Rules',
                'fra': 'Règles',
                'spa': 'Reglas',
                'por': 'Regras'
            },
            'hasSubTabs': false,
            'textTranslationKey': {
                'eng': `<div><embed src="${rules.eng}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
                'fra': `<div><embed src="${rules.fra}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
                'spa': `<div><embed src="${rules.spa}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
                'por': `<div><embed src="${rules.por}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`
            }
        }
    ]
};